import { Map } from 'immutable';

import {
  OPEN_FENCE_SAVE_CONFIRMATION_DIALOG,
  CLOSE_FENCE_CONFIRMATION_DIALOG,
  OPEN_POI_UPDATE_CONFIRMATION_DIALOG,
  CLOSE_POI_UPDATE_CONFIRMATION_DIALOG,
  RESET_FENCE,
  NEW_FENCE_DRAWN,
  SET_NEW_FENCE_MAP_CENTER,
  UPDATE_POI_CENTER,
} from './actions';

const defaultState = {
  dialogOpen: false,
  fence: null,
  location: null,
  poiUpdateDialogOpen: false,
  newPoiCenter: null,
}

const unsavedFence = (state = Map(defaultState), action) => {
  switch (action.type) {
    case OPEN_FENCE_SAVE_CONFIRMATION_DIALOG:
      return state.setIn(['dialogOpen'], true);
    case CLOSE_FENCE_CONFIRMATION_DIALOG:
      return state.setIn(['dialogOpen'], false);
    case OPEN_POI_UPDATE_CONFIRMATION_DIALOG:
      return state.setIn(['poiUpdateDialogOpen'], true);
    case CLOSE_POI_UPDATE_CONFIRMATION_DIALOG:
      return state.setIn(['poiUpdateDialogOpen'], false);
    case RESET_FENCE:
      return state.setIn(['fence'], null);
    case NEW_FENCE_DRAWN:
      return state.setIn(['fence'], {
        type: action.payload.fence.type,
        coordinates: action.payload.fence.coordinates,
      });
    case SET_NEW_FENCE_MAP_CENTER:
      return state.setIn(['location'], action.payload.location);
    case UPDATE_POI_CENTER:
      return state.setIn(['newPoiCenter'], {
        poiId: action.payload.poiId, 
        geo: action.payload.geo
      });
    default:
      return state
  }
}

export default unsavedFence


// WEBPACK FOOTER //
// ./src/pois/unsavedFenceReducer.js